<template>
  <v-autocomplete
    v-model="nonconformityValue"
    @input="handleInput"
    :clearable="clearable"
    :dense="dense"
    :disabled="disabled"
    :items="nonconformities"
    :item-value="itemValue"
    :loading="isLoading"
    :multiple="multiple"
    :outlined="outlined"
    :readonly="readonly"
    :return-object="returnObject"
    :rules="rules"
    :search-input="search"
    item-text="nc_number"
    :label="$tc('categories.nonconformity.name', 1)"
  ></v-autocomplete>
</template>

<script>
import NonConformityService from "@/services/NonConformityService"
export default {
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    itemValue: {
      type: String,
      default: "pk"
    },
    dense: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    }
  },
  data() {
    return {
      nonconformity_id: null,
      search: "",
      isLoading: false,
      nonconformityValue: null,
      nonconformities: []
    }
  },
  created() {
    if (this.value) {
      this.nonconformityValue = this.value
    } else if (this.$route.query.nonconformity) {
      this.nonconformity_id = this.$route.query.nonconformity
    } else if (this.$route.params.id) {
      this.nonconformity_id = this.$route.params.id
    }
    this.getNonConformity()
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) this.nonconformityValue = newValue
      }
    }
  },
  methods: {
    getNonConformity() {
      this.isLoading = true
      NonConformityService.get(this, this.$store.state.app.project.id)
        .then(r => {
          if (this.nonconformity_id) {
            const found = r.results.find(o => o.id == this.nonconformity_id)
            if (found) {
              this.nonconformityValue = this.nonconformity_id //this.returnObject ? found : found.id
              this.handleInput()
            }
          }
          this.nonconformities = r.results
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleInput() {
      const $ = this
      this.$nextTick(() => {
        $.$emit("input", this.nonconformityValue)
      })
    }
  }
}
</script>
